import React from 'react';
import { useAnnouncerStyles } from './Announcer.styles';
export var Announcer = function (_a) {
    var isEnabled = _a.isEnabled, text = _a.text;
    var styles = useAnnouncerStyles();
    return isEnabled ? (React.createElement("div", { "aria-live": "assertive", "aria-label": "announcement", tabIndex: -1, role: "alert", className: styles.container }, text)) : null;
};
//# sourceMappingURL=Announcer.js.map